import { render, staticRenderFns } from "./ShoppingConfirmPassword.vue?vue&type=template&id=4a2cc674&"
import script from "./ShoppingConfirmPassword.vue?vue&type=script&lang=js&"
export * from "./ShoppingConfirmPassword.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingConfirmPassword.vue?vue&type=style&index=0&id=4a2cc674&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports